import { forwardRef } from 'react';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M16.3627 11.4536C17.1285 10.5576 17.6082 9.4125 17.6082 8.14286C17.6082 5.30705 15.2938 3 12.449 3H7.2898C6.57759 3 6 3.57576 6 4.28571V19.7143C6 20.4242 6.57759 21 7.2898 21L13.7388 20.9998C16.5836 20.9998 18.898 18.6927 18.898 15.8569C18.898 13.9808 17.8742 12.3536 16.3627 11.4536ZM8.57959 5.57183H12.449C13.8718 5.57183 15.0286 6.72496 15.0286 8.14326C15.0286 9.56156 13.8718 10.7147 12.449 10.7147H8.57959V5.57183ZM13.7388 18.4286H8.57959V13.2857H13.7388C15.1616 13.2857 16.3184 14.4388 16.3184 15.8571C16.3184 17.2754 15.1616 18.4286 13.7388 18.4286Z' />
        </SvgIcon>
    );
});
